import React from 'react'

function SuccessSvg() {
    return (
        <svg
            id="Blue_verified_tick_vector_icon"
            fill="#0ad07b"
            data-name="Blue verified tick vector icon"
            height="200px"
            width="200px"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 4000 4000"
        >
            <g id="Blue_verified_tick" data-name="Blue verified tick">
                <path
                    className="cls-2"
                    d="m3279.32,2000c0,93.37-126.63,171.27-146.49,258.63-20.5,90.21,59.3,215.2,20.04,296.59-39.91,82.73-187.8,98.02-244.54,169.08-57.02,71.41-39.24,218.92-110.65,275.94-71.06,56.74-210.84,6.8-293.57,46.71-81.39,39.26-129.21,180.07-219.42,200.57-87.36,19.86-191.32-85.8-284.7-85.8s-197.33,105.66-284.7,85.8c-90.21-20.5-138.03-161.31-219.42-200.57-82.73-39.91-222.51,10.03-293.57-46.71-71.41-57.02-53.63-204.53-110.64-275.94-56.74-71.06-204.63-86.35-244.54-169.08-39.26-81.39,40.54-206.38,20.04-296.59-19.86-87.36-146.49-165.25-146.49-258.63s126.63-171.27,146.49-258.63c20.5-90.21-59.3-215.2-20.04-296.59,39.91-82.73,187.8-98.02,244.54-169.08,57.02-71.41,39.24-218.92,110.65-275.94,71.06-56.74,210.84-6.8,293.57-46.71,81.39-39.26,129.21-180.07,219.42-200.57,87.36-19.86,191.32,85.8,284.7,85.8s197.33-105.66,284.7-85.8c90.21,20.5,138.03,161.31,219.42,200.57,82.73,39.91,222.51-10.03,293.57,46.71,71.41,57.02,53.63,204.53,110.64,275.94,56.74,71.06,204.63,86.35,244.54,169.08,39.26,81.39-40.54,206.38-20.04,296.59,19.86,87.36,146.49,165.25,146.49,258.63Z"
                />
                <path
                    fill="#fff"
                    className="cls-1"
                    d="m2642.82,1516.49c-59.57-59.57-156.51-59.57-216.08,0l-640.31,640.31c-1.39,1.39-3.64,1.39-5.03,0l-208.13-208.12c-59.57-59.57-156.51-59.57-216.08,0-59.57,59.57-59.57,156.51,0,216.08l318.69,318.68c28.86,28.86,67.23,44.75,108.04,44.75s79.18-15.89,108.04-44.75l750.86-750.86c59.57-59.58,59.57-156.52,0-216.08Z"
                />
            </g>
            <g>
                <circle className="cls-2" cx="2000" cy="470" r="71" />
                <circle className="cls-2" cx="2000" cy="3530" r="71" />
            </g>
            <g>
                <circle className="cls-2" cx="918.13" cy="918.13" r="71" />
                <circle className="cls-2" cx="3081.87" cy="3081.87" r="71" />
            </g>
            <g>
                <circle className="cls-2" cx="470" cy="2000" r="71" />
                <circle className="cls-2" cx="3530" cy="2000" r="71" />
            </g>
            <g>
                <circle className="cls-2" cx="918.13" cy="3081.87" r="71" />
                <circle className="cls-2" cx="3081.87" cy="918.13" r="71" />
            </g>
        </svg>
    )
}

export default SuccessSvg